import { render } from "./BonurileMele.vue?vue&type=template&id=35656dcd&scoped=true"
import script from "./BonurileMele.vue?vue&type=script&lang=js"
export * from "./BonurileMele.vue?vue&type=script&lang=js"

import "./BonurileMele.vue?vue&type=style&index=0&id=35656dcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35656dcd"]])

export default __exports__